import { RefundModel } from 'api-hooks/refund/refund';
import * as React from 'react';

interface RefundFormStateResult {
  refund?: RefundModel;
  editableInformation: boolean;
  editableCustomer: boolean;
  editableAgent: boolean;

  setEditableForm: (value: {
    information: boolean;
    customer: boolean;
    agent: boolean;
  }) => void;
}

interface RefundFormStateProviderProps {
  children: React.ReactNode;
}

const context = React.createContext<RefundFormStateResult>({
  refund: undefined,
  editableInformation: false,
  editableAgent: false,
  editableCustomer: false,
  setEditableForm() {},
});

export const { Provider } = context;

export function RefundFormStateProvider(props: RefundFormStateProviderProps) {
  const [editableInformation, setStateInformation] = React.useState(false);
  const [editableAgent, setStateAgent] = React.useState(false);
  const [editableCustomer, setStateCustomer] = React.useState(false);

  const setEditableForm = React.useCallback(
    (value: { information: boolean; customer: boolean; agent: boolean }) => {
      setStateInformation(value.information);
      setStateAgent(value.agent);
      setStateCustomer(value.customer);
    },
    [],
  );

  const value = React.useMemo(
    () => ({
      editableAgent,
      editableCustomer,
      editableInformation,
      setEditableForm,
    }),
    [editableAgent, editableCustomer, editableInformation, setEditableForm],
  );

  return <Provider value={value}>{props.children}</Provider>;
}

export function useRefundFormState() {
  return React.useContext(context);
}
